module.exports = __webpack_public_path__ + "static/media/smoke-heat.619665b0.svg";